'use strict';

const trackingUtils = require('od-modules/utils/tracking.utils');

const BaseView = require('components-framework/view/base.view');

const perkTypeMap = {
    CABIN_BAG: 'cabin',
    CHECKED_BAG: 'checked',
    STANDARD_SEAT_RESERVATION: 'seat',
    CHANGE_BEFORE_DEPARTURE: 'change',
    REFUND_BEFORE_DEPARTURE: 'refund',
};

const perkAvailability = {
    INCLUDED: 'INCLUDED',
    NOT_OFFERED: 'NOT_OFFERED',
    OTHER_SERVICE: 'OTHER_SERVICE',
};

const serviceOrderConfig = {
    CABIN_BAG: ['CABIN_BAG'],
    CHECKED_BAG: ['CHECKED_BAG'],
    STANDARD_SEAT_RESERVATION: ['STANDARD_SEAT_RESERVATION', 'PREFERRED_SEAT_RESERVATION', 'EXTRA_LEGROOM_SEAT_RESERVATION'],
    CHANGEABLE: ['CHANGE_AFTER_DEPARTURE', 'CHANGE_BEFORE_DEPARTURE',
        'EARLIER_FLIGHT_ON_TRAVEL_DAY', 'REFUND_AFTER_DEPARTURE', 'REFUND_BEFORE_DEPARTURE'],
};
const perkTypeTrackingOrder = ['CABIN_BAG', 'CHECKED_BAG', 'STANDARD_SEAT_RESERVATION', 'CHANGE_BEFORE_DEPARTURE', 'REFUND_BEFORE_DEPARTURE'];
const scrollEventName = 'ffAnimatePopup';

module.exports = BaseView.extend({

    selectors: {
        fareUpgradePopup: '.fare_upgrade_details_popup',
        fareUpgradeLoading: '.dialog_update_farefamilies',
        fareUpgradeLoadingOpen: 'open',
        fareUpgradeItem: '.fare_item',
        fareUpgradeButton: '.select_ff_btn',
        fareUpgradeRadio: '.select_ff_radio',
        fareUpgradeLightbox: '.fare_family_lightbox',
        ffAnimatedMessage: '.ff_animated_message',
    },
    events: {
        'tap .fare_open': 'onTapOpen',
        'tap .select_ff_radio': 'onSelectFare',
    },
    statusClasses: {
        CLOSED: '.fare_panel_close, .fare_families_panel_continueBtn',
        CHECKED: 'checked',
    },
    iconClasses: {
        INCLUDED: 'odf-icon-tick odf-text-positive',
        AVAILABLE_AT_A_CHARGE: 'odf-icon-tick odf-text-mono-color-05',
        NOT_OFFERED: 'odf-icon-cross-light odf-text-negative',
        CHECKED_BAG: 'odf-icon-baggage',
        STANDARD_SEAT_RESERVATION: 'odf-icon-seat',
        CHANGEABLE: 'odf-icon-calendar',
    },
    fareUpgradeLightbox: null,

    initialize: function() {
        this.bindEvents();
    },
    bindEvents: function() {
        this.listenTo(this.model, 'repaintPrices', this.renderize);
    },
    renderize: function() {
        const fareUpgrades = this.model.get('fareUpgrades');
        const checked = this.model.get('fareFamily');
        if (!Odigeo._.isEmpty(fareUpgrades) && fareUpgrades.length) {
            const formattedFareUpgrades = this.getFormattedFareUpgrades(fareUpgrades)
                .map((item) => {
                    item.checkedClass = item.name === checked ? this.statusClasses.CHECKED : '';
                    return item;
                });
            const templateParams = Odigeo._.extend(formattedFareUpgrades, this.getTemplateParams());
            const selectedFareId = this.getIdFareSelected(formattedFareUpgrades);
            const selectedFare = formattedFareUpgrades[selectedFareId];
            selectedFare.checkedClass = this.statusClasses.CHECKED;

            this.toogleNags(selectedFareId);
            this.$el.html(this.templates.main(templateParams));
            this.$el.find(this.selectors.fareUpgradeLightbox).html(this.templates.panel(templateParams));
            this.fareUpgradeLightbox = new Odigeo.UIElements.Lightbox(this.$el.find(this.selectors.fareUpgradeLightbox), {
                overFullPage: false,
                closeOnOuterClick: true,
                closingClass: this.statusClasses.CLOSED,
            });
            this.addScrollListener();
        }
    },
    getTemplateParams: function() {
        return Odigeo._.extend(this.model.getTemplateParams(), {
            keys: this.keys,
            selectFlightButton: this.getButtonText(),
        });
    },
    getIdFareSelected: function(fareUpgrades) {
        const selected = fareUpgrades.findIndex((fareUpgrade) => {
            return fareUpgrade.checkedClass === this.statusClasses.CHECKED;
        });
        return selected < 0 ? 0 : selected;
    },
    getButtonText: function() {
        return Odigeo.Utils.pluralizeAll(this.getTranslation('selectFlightButton'), 0);
    },
    hasPerkTypeTranslation: function(fareUpgradePerkType) {
        return !(Odigeo._.isEmpty(Odigeo._.trim(this.getTranslation(fareUpgradePerkType))));
    },
    getFormattedFareUpgrades: function(fareUpgrades) {
        const allIncludedPerks = this.getAllIncludedPerks(fareUpgrades);
        return Odigeo._.map(fareUpgrades, Odigeo._.bind(function(item) {
            return Odigeo._.extend({}, item, {
                orderedPerks: this.getExtendedViewPerks(item.fareUpgradePerks, allIncludedPerks),
                filteredPerks: this.getFilteredPerks(item.fareUpgradePerks),
                areHidden: Odigeo._.some(item.fareUpgradePerks, Odigeo._.bind(function(perk) {
                    return perk.availability !== perkAvailability.INCLUDED && this.hasPerkTypeTranslation(perk.fareUpgradePerkType);
                }, this)),
                areIncluded: Odigeo._.some(item.fareUpgradePerks, Odigeo._.bind(function(perk) {
                    return perk.availability === perkAvailability.INCLUDED && this.hasPerkTypeTranslation(perk.fareUpgradePerkType);
                }, this)),
                totalPrice: this.formatPrice(item.price + this.model.getPrice()),
            });
        }, this)).sort((a, b) => {
            return a.price - b.price;
        });
    },
    getFilteredPerks: function(fareUpgradePerks) {
        const filteredPerks = [];
        const includedPerks = this.getFareUpgradePerkByAvailability(fareUpgradePerks, perkAvailability.INCLUDED);
        for (let service in serviceOrderConfig) {
            if (Object.prototype.hasOwnProperty.call(serviceOrderConfig, service)) {
                let perk = {};
                serviceOrderConfig[service].some((perkType) => {
                    const perksByType = this.getFareUpgradePerkByType(includedPerks, perkType);
                    const isAvailable = !Odigeo._.isEmpty(perksByType);
                    const baggageInfo = isAvailable && perksByType.fareUpgradePerkTypeGroup === 'BAG' ? this.getBagInfo(perksByType) : '';
                    perk = {
                        isAvailable,
                        baggageInfo,
                    };
                    return isAvailable;
                });
                filteredPerks.push({
                    isAvailable: perk.isAvailable,
                    baggageInfo: perk.baggageInfo,
                    iconAvailability: this.iconClasses[perk.isAvailable ? perkAvailability.INCLUDED : perkAvailability.NOT_OFFERED],
                    icon: this.iconClasses[service] || '',
                    nameTranslated: this.getTranslation(service),
                    fareUpgradePerkType: service,
                });
            }
        }
        return filteredPerks;
    },
    getExtendedViewPerks: function(fareUpgradePerks, allIncludedPerks) {
        const includedPerks = this.getFareUpgradePerkByAvailability(fareUpgradePerks, perkAvailability.INCLUDED);
        return allIncludedPerks.map((perk) => {
            perk.isAvailable = includedPerks.some((item) => item.fareUpgradePerkType === perk.fareUpgradePerkType);
            perk.baggageInfo = perk.fareUpgradePerkTypeGroup === 'BAG' ? this.getBagInfo(perk) : '';
            perk.nameTranslated = this.getTranslation(perk.fareUpgradePerkType);
            perk.iconClass = this.iconClasses[perk.isIncluded ? perkAvailability.INCLUDED : perkAvailability.NOT_OFFERED];
            return Object.assign({}, includedPerks, perk);
        });
    },
    getAllIncludedPerks: function(fareUpgrades) {
        let allIncludedPerks = [];
        fareUpgrades.reverse().forEach((fare) => {
            allIncludedPerks = allIncludedPerks.concat(
                this.getFareUpgradePerkByAvailability(fare.fareUpgradePerks, perkAvailability.INCLUDED));
        });
        allIncludedPerks = Odigeo._.uniq(allIncludedPerks, 'fareUpgradePerkType');
        return allIncludedPerks;
    },
    getBagInfo: function(perk) {
        const perkUnits = (Odigeo._.isNull(perk.units) ? 1 : perk.units);
        let bagInfo = perkUnits + ' ';
        bagInfo += Odigeo.Utils.pluralizeAll(this.getTranslation('bags'), perkUnits) + ' ';
        if (perk.weight > 0) {
            bagInfo += perk.weight + ' ' + this.getTranslation('kg');
        }
        return bagInfo;
    },
    getTranslation: function(key) {
        return Odigeo._.get(this.keys, key, '');
    },
    formatPrice: function(price) {
        return Odigeo.Utils.splitFormatedCurrency(price);
    },
    onTapOpen: function(e) {
        e.stopPropagation();
        e.preventDefault();
        this.fareUpgradeLightbox.toggle();
        const $currentTarget = $(e.currentTarget);
        const trackingParam = this.getUpgradeFareTrackingParam($currentTarget.data('name'), $currentTarget.data('price'));
        $currentTarget.toggleClass('open opened');
        trackingUtils.trackEvent('pax_farefam', 'open_info_farefam:all-fare:' + trackingParam);
    },
    getUpgradeFareTrackingParam: function(fareUpgradeName, fareUpgradeAmount) {
        if (fareUpgradeAmount === 0) {
            return 'standard';
        }
        const fareUpgrade = Odigeo._.find(this.getFormattedFareUpgrades(this.model.get('fareUpgrades')), function(item) {
            return item.name === fareUpgradeName;
        }) || {};
        const fareUpgradePerks = fareUpgrade.fareUpgradePerks || [];
        return this.getTrackingPerks(fareUpgradePerks);
    },
    getTrackingPerks: function(perks) {
        return perkTypeTrackingOrder.map(function(perkType) {
            return this.getFareUpgradePerkByType(perks, perkType).availability === perkAvailability.INCLUDED ?
                this.getPerkTypeMapped(perkType) :
                'na';
        }, this).join('-');
    },
    getPerkTypeMapped: function(key) {
        return key in perkTypeMap ? perkTypeMap[key] : key;
    },
    getFareUpgradePerkByType: function(perks, perkType) {
        return Odigeo._.find(perks, function(perk) {
            return perk.fareUpgradePerkType === perkType;
        }) || {};
    },
    getFareUpgradePerkByAvailability: function(fareUpgradePerks, availability) {
        return Odigeo._.filter(fareUpgradePerks, function(perk) {
            return perk.availability === availability && perk.fareUpgradePerkType !== perkAvailability.OTHER_SERVICE;
        }) || {};
    },
    onSelectFare: function(e) {
        const $selected = $(e.currentTarget);
        const data = {
            id: $selected.data('id'),
            fareFamily: $selected.data('name'),
            fareFamilyAmount: $selected.data('price'),
        };
        if (this.fareUpgradeLightbox.isOpen()) {
            this.fareUpgradeLightbox.toggle(false);
        }
        this.updateModelOnSelect(data);
        this.toogleNags(data.id);
        this.$el.find(this.selectors.fareUpgradeLoading).addClass(this.selectors.fareUpgradeLoadingOpen);
        trackingUtils.trackEvent('pax_farefam', 'select_farefam:all-fare:' +
            this.getUpgradeFareTrackingParam(data.fareFamily, data.fareFamilyAmount));
        Odigeo.trigger(this.id + ':fareFamilySelected', this.getRequesForBookFlightHandler());
    },
    toogleNags: function(id) {
        Odigeo.Session.set('fareFamiliesSelectedDisableNags', Odigeo.AB.isHidePaxNagsWithFare && id !== 0);
    },
    updateModelOnSelect: function(data) {
        this.model.set({
            selectedIndex: data.id,
            fareFamily: data.fareFamily,
            fareFamilyAmount: data.fareFamilyAmount,
        });
        this.model.setFareFamilyFromSession();
    },
    addScrollListener: function() {
        Odigeo.addScrollListener({
            name: scrollEventName,
            fn: Odigeo._.throttle(this.onScroll.bind(this), 100),
            pageName: Odigeo.History.getPageNameFromFragment(),
        });
    },
    onScroll: function() {
        const $ffAnimatedMessage = this.$el.find(this.selectors.ffAnimatedMessage);
        if ($ffAnimatedMessage.length) {
            $ffAnimatedMessage.addClass('od-fare-upgrade-animate-slideUp');
            Odigeo.removeScrollListener(scrollEventName);
        }
    },
    getRequesForBookFlightHandler: function() {
        const data = this.model.get('data');
        return {
            itinerarySearchRequest: {
                externalSelectionRequest: {
                    fareItineraryKey: data.data.fareItineraryKey,
                    searchId: data.data.searchId,
                    segmentKeys: data.flightNumbers,
                    flightNumbers: data.data.flightNumbers,
                    priceWithoutDiscountSelected: data.data.priceWithoutDiscountSelected,
                },
            },
            fareItineraryKey: data.data.fareItineraryKey,
            searchId: data.data.searchId,
            price: data.data.price,
            segmentKeys: data.data.segmentKeys,
            flightNumbers: data.data.flightNumbers,
            priceWithoutDiscountSelected: data.data.priceWithoutDiscountSelected,
            promotedItineraryTypes: data.data.promotedItineraryTypes,
            refundableFareUpgrade: data.data.refundableFareUpgrade,
            refundableFareUpgradePrice: data.data.refundableFareUpgradePrice,
            refundableFareUpgradeShown: data.data.refundableFareUpgradeShown,
            fareFamily: this.model.get('fareFamily'),
            fareFamilyAmount: this.model.get('fareFamilyAmount'),
        };
    },
});
